/* eslint-disable max-lines */
import { css } from 'styled-components';
import { CFMixins } from '../../../mixins';
import { CFTokens } from '../../../tokens';
import { hexOpacity } from '../../../utils';
import { CFBaseContainerTokens } from '.';
export const align = ({ bufferedProps: { align, dir, spacingMode }, }) => CFMixins.align({ align, dir, spacingMode });
export const backgroundColor = ({ bufferedProps: { background, withBackgroundBlur }, }) => {
    if (withBackgroundBlur) {
        return css `
      background-color: ${CFTokens.getCFColorValue(background, '#ffffff')}${hexOpacity(CFBaseContainerTokens.HEX_OPACITY)};
      backdrop-filter: blur(${CFBaseContainerTokens.BACKGROUND_BLUR}px);
    `;
    }
    return css `
    background-color: ${CFTokens.getCFColorValue(background)};
  `;
};
export const backgroundImage = ({ bufferedProps: { backgroundImage, backgroundImageSize = 'cover' }, }) => {
    return css `
    background-image: url(${backgroundImage});
    background-repeat: no-repeat;
    background-size: ${backgroundImageSize};
  `;
};
export const border = ({ bufferedProps: { border }, }) => {
    if (!border) {
        return null;
    }
    if (typeof border === 'string') {
        return css `
      border: ${CFTokens.getCFBorder(border)};
    `;
    }
    return CFMixins.borderAsCSS(Object.assign({}, border));
};
export const borderRadius = ({ bufferedProps: { borderRadius }, }) => {
    return borderRadius
        ? CFTokens.getCFBorderRadius(borderRadius)
        : CFTokens.BORDER_RADIUS.NONE;
};
export const flex = ({ bufferedProps: { flex } }) => flex !== undefined
    ? css `
        flex: ${flex};
      `
    : null;
export const gap = ({ bufferedProps: { gap } }) => gap ? CFTokens.getCFSpacerValue(gap) : 0;
export const height = ({ bufferedProps: { height }, }) => {
    if (!height) {
        return;
    }
    const formattedHeight = typeof height === 'number' ? `${height}px` : height;
    switch (height) {
        case 'fill':
            return css `
        height: 100%;
      `;
        case 'hug':
            return css `
        height: auto;
      `;
        default:
            return css `
        height: ${formattedHeight};
      `;
    }
};
export const orientation = ({ bufferedProps: { dir }, }) => {
    return dir === 'horizontal' ? 'row' : 'column';
};
export const padding = ({ bufferedProps: { pad }, }) => {
    return CFMixins.padding(pad);
};
export const shadow = ({ bufferedProps: { shadow }, }) => shadow
    ? css `
        box-shadow: ${CFTokens.ELEVATION[shadow.toUpperCase()]};
      `
    : null;
export const width = ({ bufferedProps: { width }, }) => {
    if (!width) {
        return;
    }
    const formattedWidth = typeof width === 'number' ? `${width}px` : width;
    switch (width) {
        case 'fill':
            return css `
        width: 100%;
      `;
        case 'hug':
            return css `
        width: auto;
      `;
        default:
            return css `
        width: ${formattedWidth};
      `;
    }
};
